import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import FeeRemindersComp from './FeeRemindersComp'

function FeeReminders() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <FeeRemindersComp/>      
        </div>
    </div>
  )
}

export default FeeReminders